import { Grid } from "@material-ui/core";
import React from "react";
import { FormGroup, Input, Label, Row, Col } from "reactstrap";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import ProfileImageUploader from "../ProfileImageUploader/ProfileImageUploader";

export const ProfileSettings = (props) => {
  const { bio, image, onImageSet, onBioSet } = props;
  return (
    <Grid
      item
      xs={12}
      md={12}
      lg={12}
      style={{
        paddingTop: 0,
        backgroundColor: "#fff",
        padding: 10,
        height: "calc(100vh - 110px)",
      }}
    >
      <ProfileImageUploader setImage={onImageSet} source={image} />
      <hr />
      <Row style={{ padding: "10px 10px 5px 10px", margin: "0px 10px" }}>
        <Col style={{ padding: 0 }}>
          <FormGroup>
            <Label>
              <EventLabel2
                name="PersonalDescription"
                groupName="Exhibitor.Admin"
              />
            </Label>
            <Input value={bio} onChange={(e) => onBioSet(e.target.value)} />
          </FormGroup>
        </Col>
      </Row>
    </Grid>
  );
};
